<template>
  <div>
    <slot v-bind:open="open"></slot>

    <modal :show="show" @closeModal="close">
      <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900 mb-2">
          Confirm removal of items
        </h3>
        <p class="text-sm text-gray-500 leading-5">Are you sure, you want to remove the following items? Once removed this action cannot be undone.</p>

        <table class="min-w-full mt-2">
          <thead>
          <tr>
            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Item Code
            </th>
            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Unit
            </th>
            <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              Qty Ordered
            </th>
          </tr>
          </thead>
          <tbody class="bg-white">
          <tr v-for="(value, itemId) in form.items" :key="`removal-${itemId}`">
            <template v-if="value === true && selectedItem(itemId)">
              <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
                {{ selectedItem(itemId).item_code }}
              </td>
              <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
                {{ selectedItem(itemId).unit }}
              </td>
              <td class="px-2 py-4 whitespace-nowrap border-b border-gray-200 text-sm leading-5 text-gray-900">
                {{ selectedItem(itemId).quantity }}
              </td>
            </template>
          </tr>
          </tbody>
        </table>

        <div class="mt-4 flex justify-end">
          <loading-button :loading="form.processing" @click="removeItems" class="btn-red" :disabled="form.processing">Remove</loading-button>
        </div>

      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "@/Shared/Modal.vue";
import LoadingButton from "@/Shared/LoadingButton.vue";

export default {
  name: 'RemoveOrderItemModal',
  components: {LoadingButton, Modal},
  props: {
    items: Array,
    checkedItems: Object,
    removeOrderItemUrl: String,
  },

  data() {
    return {
      show: false,
      form: this.$inertia.form({
        items: {}
      })
    }
  },

  computed: {
    selectedItem() {
      return itemId => {
        // if (Array.isArray(this.items) && this.items.length) {
          return this.items.find(itm => itm.id === parseInt(itemId))
        // }
        // return null
      }
    },
  },

  methods: {
    open() {
      this.form.items = this.checkedItems
      this.show = true
    },
    close() {
      this.show = false
    },
    removeItems() {
      this.form.post(this.removeOrderItemUrl, {
        preserveState: false,
      })
    }
  }
}
</script>
